import { template as template_256f5f2b92d741418b0e575b25f05350 } from "@ember/template-compiler";
import { hash } from '@ember/helper';
const JemViewFileDetails = template_256f5f2b92d741418b0e575b25f05350(`
{{#if @childStatus.uploadedData}}
  <div class="file-name text-gray-800">{{@childStatus.uploadedData.fileName}}</div>
{{/if}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default template_256f5f2b92d741418b0e575b25f05350(`
  {{yield
    (hash
      taskDetails=(component
        JemViewFileDetails
        disabled=@disabled
        notAuthorized=@notAuthorized
        isAuto=@task.isAuto
        childStatus=@childStatus
        taskConfig=@taskConfig
      )
    )
  }}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
